import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { RootState } from "../../../app/store";
import Localized from "../../../Localized";
import { changeStep } from "../../../redux/slices/windowSlice";

import ArrowCircleDownRoundedIcon from '@mui/icons-material/ArrowCircleDownRounded';

import './style.scss';
import { IconButton } from "@mui/material";
import Timer from "./timer";

const Header = () => {
    
    const dispatch = useAppDispatch();
    const { stepCurrent } = useAppSelector((state: RootState) => state.windowSlice);
    
    const getBack = () => {
        switch (stepCurrent) {
            case 1:  
            case 2:  
                return (<IconButton className="header_back" onClick={() => dispatch(changeStep(-1))}>
                            <ArrowCircleDownRoundedIcon 
                                sx={{transform: "rotate(90deg)"}}
                            />
                        </IconButton>);
        }
    }

    const getTitle = () => {
        switch (stepCurrent) {
            case 0:
                return Localized.HeaderSelectTicket;
            case 1:
                return Localized.HeaderYourOrder;
            case 2:
                return Localized.HeaderContact;    
            case 3:
                return 'Оплата'; 
            case 4:
                return Localized.HeaderFinal;     
            default:
                return 'Ошибка';    
        }
    }
    
    return (
        <header className="header">
            <div className="header_container">
                <div className="header_wrapper">
                    {getBack()}
                    <div className="header_center">
                        <h1 className="header_title">{getTitle()}</h1>
                        <Timer />
                    </div>
                </div>
            </div>
        </header>
    );    
}

export default Header;